<template>
  <div class="cliente-item">
    <div class="razao-social-cliente font-bold">{{dadosCliente.razaoSocial}}</div>
    <div class="codigo-cliente text-right">{{dadosCliente.codigoExterno}}</div>
    <div class="nome-fantasia-cliente font-bold">{{dadosCliente.nomeFantasia}}</div>
    <div class="situacao-cliente text-right">CV: {{dadosCliente.curvaCliente}}</div>
    <div class="cidade-estado-cliente text-right">{{dadosCliente.estadoCidade}}</div>
    <div class="cnpj-cliente text-left">{{aplicaMascaraCnpj(dadosCliente.cnpj)}}</div>
  </div>
</template>

<script>
import clienteDropdownItem from "./cliente-dropdown-item.js";
export default clienteDropdownItem;
</script>

<style scoped>
.cliente-item {
  flex: 1;
  display: grid;
  grid-template-rows: repeat(3, 33%);
  grid-template-columns: 50% 50%;
  max-width: calc(100vw - 100px);
}

.razao-social-cliente{
  grid-area: 1/1/1/1;
  /* max-width: 100%;
  text-overflow: ellipsis; */
}

.codigo-cliente{
  grid-area: 1/2/1/2;
}

.nome-fantasia-cliente{
  grid-area: 2/1/2/1;
}

.situacao-cliente{
  grid-area: 2/2/2/2;
}

.cidade-estado-cliente{
  grid-area: 3/2/3/2;
}

.cnpj-cliente{
  grid-area: 3/1/3/1;
}

.text-right{
  text-align: right;
}

.text-left{
  text-align: left;
}

.font-bold{
  font-weight: bold;
}

</style>
